import { ModuleLayout } from "../_shared/ModuleLayout";
export default function GrowthLayout() {
  return (
    <ModuleLayout
      testId="pureh-growth"
      eyebrow="Growth"
      title="Growth Operating System"
      subtitle="Sales pipeline, loyalty, retention, attribution — the customer compound engine."
      tabs={[
        { to: "overview",    label: "Overview" },
        { to: "sales",       label: "Sales Pipeline" },
        { to: "loyalty",     label: "Loyalty" },
        { to: "retention",   label: "Retention" },
        { to: "attribution", label: "Attribution" },
      ]}
    />
  );
}
